//@ts-nocheck
//@ts-ignore
/* eslint-disable */
import React from 'react';
import { useNav } from '../../hooks/nav';
import { ReactComponent as BackIcon } from '../../assets/images/arrowLeft.svg';
import Analytics from '@web-solutions/module-analytics';
import { t } from '@web-solutions/module-localization';
import { Title } from 'src/onboarding/components/typography/Title/Title';
import { Text } from 'src/onboarding/components/typography/Text/Text';
import Button from 'src/onboarding/components/ui/button/Button';
import jessica from '../../assets/images/jessica.png';
import styles from './style.module.scss';
import { Caption } from 'src/onboarding/components/typography/Caption/Caption';
import { ReactComponent as PeopleIcon } from '../../assets/images/peopleIcon.svg';
import { ReactComponent as ReviewIcon } from '../../assets/images/reviewIcon.svg';
import { ReactComponent as StarSvg } from '../../assets/images/star.svg';
import { ReactComponent as TimeSvg } from '../../assets/images/timeBestApp.svg';
import { ReactComponent as CosmostyleSvg } from '../../assets/images/cosmostyle.svg';
import { ReactComponent as RalsimpleSvg } from '../../assets/images/ralsimple.svg';
import { ReactComponent as ParadSvg } from '../../assets/images/parad.svg';
import { ReactComponent as PurewonSvg } from '../../assets/images/purewon.svg';
import { ReactComponent as PsSvg } from '../../assets/images/ps.svg';
import { useStore } from 'src/onboarding/store/store';
import { renderHighlightedTitle } from 'src/onboarding/helpers/renderHighlightedTitle';
import { useRemoteConfig } from 'core/hooks/use-remote-config';
import getLocale from 'src/localization/get-locale';

function DynamicProofPage({ pageConfig, onNext, onPrev }) {
  const { currentIndex } = useNav();
  const { stats } = useRemoteConfig();
  const locale = getLocale();

  const showPhotoProcessing = useStore((state) => state.showPhotoProcessing);

  const isFirst = currentIndex === 0;

  const icons = [
    <TimeSvg />,
    <CosmostyleSvg />,
    <RalsimpleSvg />,
    <ParadSvg />,
    <PurewonSvg />,
    <PsSvg />,
  ];
  const duplicatedIcons = [...icons, ...icons];

  const handleContinue = () => {
    Analytics.trackEvent(`step${currentIndex + 1}`, 'complete', {
      page: pageConfig.id,
    });
    onNext();
  };

  return (
    <div
      className={`page ${styles.top}`}
      style={showPhotoProcessing ? { marginTop: '10px' } : { marginTop: '52px' }}
    >
      {!isFirst && (
        <div className={'back'} onClick={onPrev}>
          <BackIcon />
        </div>
      )}

      <div className={'wrapper-info'}>
        <Title tag='h2'>{renderHighlightedTitle(pageConfig.title[locale])}</Title>
      </div>

      <div className={styles.feedback}>
        <div className={styles.feedbackTop}>
          <div className={styles.feedbackImgContainer}>
            <img className={styles.feedbackImg} src={jessica} alt='customer' />
          </div>
          <div className={styles.feedbackName}>
            <Caption>Jessica M.</Caption>
            <Caption size='s' style={{ color: '#B9B9B9' }}>
              September 18, 2025
            </Caption>
          </div>
          <span className={styles.feedbackRating}>
            {[...Array(5).keys()].map((_, i) => (
              <StarSvg key={i} />
            ))}
          </span>
        </div>
        <div className={styles.feedbackBody}>
          <Text size='s' semibold>
            {pageConfig.feedbackTitle[locale]}
          </Text>
          <Caption size='xs' style={{ color: '#8A8A8A' }}>
            {pageConfig.feedbackBody[locale]}
          </Caption>
        </div>
      </div>
      <div className={styles.stats}>
        <div className={styles.statsItem}>
          <PeopleIcon />
          <Caption size='l' className={styles.statsDesc}>
            {renderHighlightedTitle(stats.firstOption[locale])}
          </Caption>
        </div>
        <div className={styles.statsItem}>
          <ReviewIcon />
          <Caption size='l' className={styles.statsDesc}>
            {renderHighlightedTitle(stats.secondOption[locale])}
          </Caption>
        </div>
      </div>
      <div className={styles.content}>
        <div className={styles.list}>
          <div className={styles.animationList}>{duplicatedIcons}</div>
        </div>
      </div>

      <div className={'next-wrapper'}>
        <Button onClick={handleContinue} title={t('onboarding.analyzeBody.continue')} />
      </div>
    </div>
  );
}

export default DynamicProofPage;
